/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
export var ContentRef = (function () {
    function ContentRef(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
    return ContentRef;
}());
//# sourceMappingURL=content-ref.class.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/ng2-bootstrap/component-loader/content-ref.class.js
// module id = cpWt
// module chunks = 3